module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAL9JREFUWAntmNENgzAQQ1PEGmUENijjdRgG6AAwAWIDFkndft9PfBZSJEeKhE6xczz8caIUctVaV+zWtZLXlYEV3q1zo2riJmqiagJqP2fURNUE1H7OqJroA+PPG6ZPwniBZmrUXTi/NWr+x3+NHniaGfGdGmdUTdtETVRNQO3njJqomoDar5uMjnjzD/ZJEHhBwwwlO3EXL8Ew439PEb5uMupGo8+XqZlohl6kNdGISqZmohl6kdZEIyqZWjdEv2hke7K51OAaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus_sign_white_small.png
// module id = 25
// module chunks = 0